/**
 * This file is meant to house placeholder strings,
 * for when development is ahead of string translation
 *
 * Format for this object is { 'gensen.localization.key': 'localized strings' }
 */
export default {};
